function StandardSubSettings(data, string) {
  if (data.length !== 0 && data.module === string) {
    return data;
  }

  if (string === "Tile") {
    return {
      module: "Tile",
      apiSelected: false,
      selected: 0,
      activeTab: "tab1",
      settingsData: [],
    };
  }

  if (string === "SMHIWarning") {
    return {
      module: "SMHIWarning",
      risk: true,
      brandrisk: true,
      highTemp: true,
      location: true,
      newDataHour: 4,
    };
  }

  if (string === "VMA") {
    return {
      module: "VMA",
      notification: true,
    };
  }

  if (string === "Trafikverket") {
    return {
      module: "Trafikverket",
      notification: true,
      useLocation: false,
      maxDistance: 10,
      newDataHour: 4,
    };
  }

  if (string === "BrottsplatsKartan") {
    return {
      module: "BrottsplatsKartan",
      useArea: true,
      crimeType: "",
      newDataHour: 4,
    };
  }

  if (string === "SL") {
    return {
      module: "SL",
      notification: true,
      line: [],
      newDataHour: 4,
    };
  }
}

export default StandardSubSettings;
